import React, { Component } from "react";
import { Modal, Form, Input, Col, Row, Button, Select } from "antd";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import GoogleAddressField from "./GoogleAddressField";
import ReactTags from "react-tag-autocomplete";
import NumericInput from "../NumericInput";
import { updateClinicDetail, getBasicClinicSpecialities } from "../../services";
import { showErrorNotification, showSuccessNotification } from "../../helpers";

const FormItem = Form.Item;
const Option = Select;
class UpdateClinicLocationModal extends Component {
  state = {
    addressLine: "",
    latitude: null,
    longitude: null,
    state: null,
    isProcessing: false,
    specialities: [],
    selectedSpecialities: []
  };

  componentDidMount() {
    if (this.props.clinicDetail) this.populateState(this.props.clinicDetail);
    this.fetchSpecialities();
  }

  /*
   * @function fetchSpecialities
   * @param "searchText"
   * @description this function fetches clinic specialities
   */
  fetchSpecialities = searchText => {
    getBasicClinicSpecialities(searchText, false)
      .then(res => {
        if (res?.data?.hits?.hits?.length > 0) {
          const { hits } = res.data.hits;
          let specialities = [];
          specialities = hits.map(resObj => {
            const tempObj = resObj._source;
            return {
              name: tempObj.name,
              basic_clinic_speciality_id: tempObj.id,
              id: tempObj.id
              // major_speciality: tempObj.major_speciality
            };
          });

          this.setState({
            specialities
          });
        } else {
          this.setState({
            specialities: []
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  onSpecDelete = i => {
    const tags = this.state.selectedSpecialities.slice(0);
    tags.splice(i, 1);
    this.setState({ selectedSpecialities: tags });
  };

  onSpecAddition = tag => {
    const tags = [].concat(this.state.selectedSpecialities, tag);
    this.setState({ selectedSpecialities: tags });
  };

  /*
   * @function searchSpecialities
   * @param "value"
   * @description this function handles filter specialities
   */
  searchSpecialities = value => {
    if (value && value.length > 1) {
      const specVal = value.replace(/[^a-zA-Z ]/g, "");
      this.fetchSpecialities(specVal);
    }
  };

  populateState = profileObj => {
    let addressLine = null,
      city = null,
      state = null,
      pincode = null,
      longitude = null,
      latitude = null,
      address = null,
      beds = null,
      rooms = null,
      speciality = null,
      otherSpecialities = [];

    if (profileObj.location) {
      const { location } = profileObj;
      addressLine = location.address_line_1;
      city = location.city;
      state = location.state;
      pincode = location.zipcode;
      latitude = location.latitude;
      longitude = location.longitude;
      address = location.city;
    }
    beds = profileObj.beds_count;
    rooms = profileObj.rooms_count;

    if (profileObj.speciality) {
      speciality = profileObj.speciality.name;
    }

    if (profileObj.other_specialities) {
      profileObj.other_specialities.map(spec => {
        const obj = {};
        if (spec.basic_clinic_speciality_id) {
          obj.id = spec.basic_clinic_speciality_id;
        }
        if (spec.speciality_name) {
          obj.name = spec.speciality_name;
        }
        otherSpecialities.push(obj);
      });
    }

    this.setState({
      addressLine: addressLine && addressLine.trim(),
      city,
      state,
      latitude,
      longitude,
      address,
      selectedSpecialities: otherSpecialities
    });

    this.props.form.setFieldsValue({
      city,
      state,
      pincode,
      locality: profileObj?.location?.address_line_2,
      addressLine: addressLine && addressLine.trim(),
      beds_count: beds,
      rooms_count: rooms,
      speciality
    });
  };

  /**
   * @function handleAddressInput
   * @desc resets latitude and longitude when user types in the address fiels
   */
  handleAddressInput = addressLine => {
    this.setState({
      latitude: null,
      longitude: null,
      addressLine
    });
  };

  /**
   * @function handleSuggestSelect
   * @description show suggestion for address
   */

  handleSuggestSelect = (gmaps, description, location) => {
    if (!gmaps) return false;

    const { address_components } = gmaps;
    let pincode = "";
    let city = "";
    let neighborhood = "";
    let state = "";

    // neighbourhood
    const neighbourhoodObj = [...address_components].filter(({ types }) =>
      types.includes("neighborhood")
    )[0];
    if (neighbourhoodObj) {
      neighborhood = neighbourhoodObj.long_name;
    }

    // postal code
    const postalCodeObj = [...address_components].filter(({ types }) =>
      types.includes("postal_code")
    )[0];
    if (postalCodeObj) {
      pincode = postalCodeObj.long_name;
    }

    // city
    const cityObj = [...address_components].filter(({ types }) =>
      types.includes("administrative_area_level_2")
    )[0];
    if (cityObj) city = cityObj.long_name;
    // state
    const stateObj = [...address_components].filter(({ types }) =>
      types.includes("administrative_area_level_1")
    )[0];
    if (stateObj) state = stateObj.long_name;

    // format the description, remove the city and pincode from it
    // and then seperate it with a comma
    let formattedDescTemp = description.replace(city, "");
    formattedDescTemp = formattedDescTemp.replace(pincode, "");

    formattedDescTemp = formattedDescTemp.split(",");
    const formattedDescription = formattedDescTemp
      .filter(x => typeof x === "string" && x.trim().length > 0)
      .join(",");

    this.props.form.setFieldsValue({
      locality: neighborhood,
      city,
      pincode
    });

    this.handleAddressChange(description);

    this.setState({
      addressLine: formattedDescription,
      latitude: location.lat,
      longitude: location.lng,
      state
    });
  };

  handleChange = e => {
    const { name, value } = e.target;

    this.props.form.setFieldsValue({
      [name]: value
    });
  };

  /**
   * @function handleAddressChange
   * @param val
   * @desc sets value in address field
   */
  handleAddressChange = val => {
    this.props.form.setFieldsValue({
      addressLine: val
    });
  };

  /**
   * @function buildAddressForGeocoding
   * @param locationObj
   * @desc This method constructs/ builds an address string, which will be used for geocoding the address.
   */
  buildAddressForGeocoding = locationObj => {
    let locationForGeocode = "";
    //  address line
    if (locationObj.address_line_1) {
      if (locationForGeocode) {
        locationForGeocode = `${locationForGeocode}, ${locationObj.address_line_1}`;
      } else {
        locationForGeocode = locationObj.address_line_1;
      }
    }
    // locality
    if (locationObj.locality) {
      if (locationForGeocode) {
        locationForGeocode = `${locationForGeocode}, ${locationObj.locality}`;
      } else {
        locationForGeocode = locationObj.locality;
      }
    }
    // city
    if (locationObj.city) {
      if (locationForGeocode) {
        locationForGeocode = `${locationForGeocode}, ${locationObj.city}`;
      } else {
        locationForGeocode = locationObj.city;
      }
    }
    // state
    if (locationObj.state) {
      if (locationForGeocode) {
        locationForGeocode = `${locationForGeocode}, ${locationObj.state}`;
      } else {
        locationForGeocode = locationObj.state;
      }
    }
    // zipcode
    if (locationObj.zipcode) {
      if (locationForGeocode) {
        locationForGeocode = `${locationForGeocode}, ${locationObj.zipcode}`;
      } else {
        locationForGeocode = locationObj.zipcode;
      }
    }

    return locationForGeocode;
  };

  /**
   * @function geocodeClinicAddress
   * @param locationObj
   * @desc This method taked in the locationObj, calls a function to construct an address string and geocodes that address and returns latitude longitude of that address
   */
  geocodeClinicAddress = async locationObj => {
    let locationLatLngs = { latitude: "", longitude: "" };
    const address = this.buildAddressForGeocoding(locationObj);

    if (address) {
      const results = await geocodeByAddress(address);
      if (results && results.length > 0) {
        locationLatLngs = getLatLng(results[0]).then(({ lat, lng }) => {
          locationLatLngs = {
            latitude: lat,
            longitude: lng
          };
          return locationLatLngs;
        });
      }
    }

    return locationLatLngs;
  };

  handleSubmit = e => {
    if (e) e.preventDefault();
    const { clinicDetail } = this.props;
    let locationObj = {};
    let finalLatlngs = { latitude: "", longitude: "" };
    const {
      latitude,
      longitude,
      state,
      addressLine,
      clinicId,
      selectedSpecialities
    } = this.state;
    this.props.form.validateFieldsAndScroll(async (err, value) => {
      if (!err) {
        // if latitude and longitude are already present, then do not geocode the address, else geocode it
        if (
          (addressLine || value.city || value.pincode || value.locality) &&
          !latitude &&
          !longitude
        ) {
          locationObj = {
            address_line_1: addressLine,
            city: value.city,
            zipcode: value.pincode,
            locality: value.locality,
            state
          };
          finalLatlngs = await this.geocodeClinicAddress(locationObj);
        }

        let formattedAddressLine = addressLine;
        const cityTempVal = value.city;

        // format the description, remove the city and pincode from it
        // and then seperate it with a comma
        formattedAddressLine = formattedAddressLine.replace(cityTempVal, "");
        formattedAddressLine = formattedAddressLine.replace(value.pincode, "");

        formattedAddressLine = formattedAddressLine.split(",");
        const formattedDescription = formattedAddressLine
          .filter(x => typeof x === "string" && x.trim().length > 0)
          .join(",");

        const finalObj = {
          clinic_details: {
            id: clinicDetail.id,
            location: {
              address_line_1: formattedDescription,
              address_line_2: value.locality,
              city: value.city,
              zipcode: value.pincode,
              latitude: finalLatlngs.latitude
                ? finalLatlngs.latitude
                : latitude,
              longitude: finalLatlngs.longitude
                ? finalLatlngs.longitude
                : longitude,
              state
            },
            rooms_count: value.rooms_count,
            beds_count: value.beds_count
          }
        };

        if (value.speciality) {
          finalObj.clinic_details.speciality = {
            name: value.speciality
          };
        }

        if (selectedSpecialities) {
          const otherSpecialities = [];
          selectedSpecialities.map(spec => {
            const obj = {};
            if (spec.id) {
              obj.basic_clinic_speciality_id = spec.id;
            }
            if (spec.name) {
              obj.name = spec.name;
            }
            otherSpecialities.push(obj);
          });
          finalObj.clinic_details.other_specialities = otherSpecialities;
        }

        this.setState({ isProcessing: true });
        updateClinicDetail(clinicDetail.id, finalObj).then(response => {
          this.setState({ isProcessing: false });
          if (response?.data?.success) {
            showSuccessNotification("Clinic details updated successfully");
            this.props.toggleModal(false, true);
          } else {
            showErrorNotification(
              "There was some error while processing your request."
            );
          }
        });
      }
    });
  };

  render() {
    const { toggleModal, showModal, clinicDetail } = this.props;
    const { addressLine, specialities, selectedSpecialities } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        visible={showModal}
        title={
          clinicDetail.is_hospital
            ? "Update hospital details"
            : "Update clinic details"
        }
        footer={null}
        onCancel={() => toggleModal(false)}
        className="form-type-modal"
      >
        <Form layout="vertical">
          <Row type="flex" gutter={16} align="top">
            <Col span={12}>
              <FormItem label="Address" className="remove-colon-lbl">
                {getFieldDecorator("addressLine", {
                  rules: [
                    {
                      required: true,
                      message: "Please select address"
                    }
                  ]
                })(
                  <GoogleAddressField
                    initialValue={addressLine}
                    suggestSelect={this.handleSuggestSelect}
                    name="addressLine"
                    onChange={this.handleAddressInput}
                    value={addressLine}
                  />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Locality" className="remove-colon-lbl">
                {getFieldDecorator(
                  "locality",
                  {}
                )(<Input onChange={this.handleChange} name="locality" />)}
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" gutter={16} align="top">
            <Col span={12}>
              <FormItem label="City" className="places-box">
                {getFieldDecorator("city", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter the city"
                    }
                  ]
                })(<Input onChange={this.handleChange} name="city" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Zipcode" className="remove-colon-lbl">
                {getFieldDecorator("pincode", {
                  rules: [
                    {
                      required: true,
                      message: "Please enter zipcode"
                    }
                  ]
                })(<NumericInput name="pincode" />)}
              </FormItem>
            </Col>
          </Row>
          {clinicDetail && clinicDetail.is_hospital && (
            <>
              <Row type="flex" gutter={16} align="top">
                <Col span={12}>
                  <FormItem label="No. of rooms" className="places-box">
                    {getFieldDecorator(
                      "rooms_count",
                      {}
                    )(<NumericInput name="rooms_count" />)}
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem label="No. of beds" className="remove-colon-lbl">
                    {getFieldDecorator(
                      "beds_count",
                      {}
                    )(<NumericInput name="beds_count" />)}
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <FormItem label="Hospital Speciality" className="places-box">
                    {getFieldDecorator(
                      "speciality",
                      {}
                    )(
                      <Select
                        showSearch
                        filterOption={false}
                        onSearch={value => this.fetchSpecialities(value)}
                      >
                        {specialities.length > 0 &&
                          specialities.map(speciality => (
                            <Option
                              key={speciality.basic_clinic_speciality_id}
                              value={speciality.name}
                            >
                              {speciality.name}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col>
                  <FormItem label="Other Specialities" className="places-box">
                    {getFieldDecorator(
                      "other_specialities",
                      {}
                    )(
                      <ReactTags
                        tags={selectedSpecialities}
                        suggestions={specialities}
                        onDelete={this.onSpecDelete}
                        onAddition={this.onSpecAddition}
                        placeholderText="Add specialities"
                        onInput={this.fetchSpecialities}
                        allowNew
                      />
                    )}
                  </FormItem>
                </Col>
              </Row>
            </>
          )}

          <Row className="no-lrmargin px-0">
            <Col span={24}>
              <Button
                type="primary"
                onClick={this.handleSubmit}
                // disabled={isUploading || photosUploading}
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(UpdateClinicLocationModal);
